import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/fr/communaute')({
  component: Outlet,
})
